var map = {
	"./role-consultant-agency-icon.svg": 3342,
	"./role-designer-icon.svg": 7698,
	"./role-founder-ceo-icon.svg": 69694,
	"./role-it-developer-icon.svg": 34645,
	"./role-manager-icon.svg": 51722,
	"./role-marketer-icon.svg": 69812,
	"./role-other-icon.svg": 85575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41235;